'use strict';

export default function f(countries) {
  'ngInject';

  return function (value) {
    var formattedValue = value && value.name;
    var countryCode = value && value.countryCode;

    if (formattedValue && countryCode) {
      formattedValue = countries[countryCode].name;
    }

    return formattedValue;
  };
}



// WEBPACK FOOTER //
// ./app/src/filters/country_filter.js